window.TapcartUtils = {
  async init() {
    const sdkLoaded = await this.sdkLoaded();

    if (!sdkLoaded) {
      return;
    }

    // if (await this.tapcartInitialized()) {
    //   //reload pages when they are back in focus
    //   document.addEventListener('visibilitychange', () => {
    //     if (!document.hidden) {
    //       window.location.reload();
    //     }
    //   });
    // }
  },

  async sdkLoaded() {
    if (window.Tapcart) {
      console.log('Tapcart script already loaded');
      return true;
    }

    return new Promise((resolve, reject) => {
      let iterationCount = 0;
      const checkTapcartScriptLoaded = setInterval(() => {
        iterationCount++;
        if (window.Tapcart) {
          console.log('Tapcart script loaded');
          clearInterval(checkTapcartScriptLoaded);
          resolve(true);
        }
        if (iterationCount >= 100) {
          console.log('Tapcart script not loaded');
          clearInterval(checkTapcartScriptLoaded);
          resolve(false);
        }
      }, 50);
    });
  },

  async tapcartInitialized() {
    const sdkLoaded = await this.sdkLoaded();
    if (!sdkLoaded) {
      return false;
    }

    return new Promise((resolve, reject) => {
      let iterationCount = 0;
      const checkTapcartInitialized = setInterval(() => {
        iterationCount++;
        if (window.Tapcart.isInitialized) {
          console.log('Tapcart initialized');
          clearInterval(checkTapcartInitialized);
          resolve(true);
        }
        if (iterationCount >= 10) {
          console.log('Tapcart not initialized');
          clearInterval(checkTapcartInitialized);
          resolve(false);
        }
      }, 50);
    });
  },

  addLoadingOverlay() {
    document.body.style.overflow = 'hidden';
    const overlay = document.createElement('div');
    overlay.id = 'loading-overlay';
    overlay.style = `
      position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;
      background:rgba(255,255,255,0.8);pointer-events:all;
    `;
    overlay.innerHTML = `
      <div style="display:flex;flex-direction:column;align-items:center;">
        <div style="margin-top:16px;font-size:16px;color:#333;">Loading...</div>
      </div>
    `;
    document.body.appendChild(overlay);
  },

  removeLoadingOverlay() {
    const overlay = document.getElementById('loading-overlay');
    if (overlay) {
      overlay.remove();
    }
    document.body.style.overflow = '';
  },

  async multipassLogin(email, baseUrl, hmac) {
    if (!email || typeof email !== 'string' || !email.trim()) {
      console.error('Invalid email provided for login');
      return;
    }
    email = email.trim().toLowerCase();

    if ((await this.tapcartInitialized()) === false) {
      return;
    }

    if (Tapcart.variables.customer) {
      console.log('Customer already logged in');
      return;
    }

    this.addLoadingOverlay();

    const multipassToken = await this.fetchMultipassToken(email, baseUrl, hmac);

    if (!multipassToken) {
      console.error('Failed to retrieve multipass token');
      this.removeLoadingOverlay();
      return;
    }

    Tapcart.action(
      'login/multipass',
      {
        email,
        multipassToken,
      },
      {
        onSuccess: (result) => {
          console.log('Tapcart login successful:', result);
          setTimeout(() => {
            TapcartUtils.openScreen('internal', 'account');
          }, 500);
        },
        onError: (result) => {
          console.error('Tapcart login error:', result);
          TapcartUtils.removeLoadingOverlay();
        },
      },
    );
  },

  async fetchMultipassToken(email, baseUrl, hmac, retries = 3, delay = 500) {
    const url = `${baseUrl}/api/multipass`;

    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'x-shopify-shop-domain': window.Shopify.shop,
            'x-shopify-hmac-sha256': hmac,
          },
          body: JSON.stringify({ email }),
        });
        if (!response.ok) {
          if (response.status >= 500 && response.status < 600) {
            throw new Error(`Server error! status: ${response.status}`);
          } else {
            const data = await response.json().catch(() => ({}));
            return data.multipassToken || null;
          }
        }
        const data = await response.json();
        return data.multipassToken || null;
      } catch (error) {
        if (i === retries - 1) {
          throw error;
        }
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  },
};

TapcartUtils.init();
